import React, { useMemo } from 'react'

import HeadData from 'components/Common/HeadData'
import { isTourPurchasable } from 'selectors/TourV2/tourV2OfferPageSelectors'

interface Props {
  offer: App.Tours.TourV2Offer;
  variation: App.Tours.TourV2OfferVariation;
}

function TourV2HeadData(props: Props) {
  const { offer, variation } = props

  const description = `${variation.description}. Book now with Luxury Escapes.`
  const image = variation.images[0]?.id
  const imageAlt = image && variation.name
  const title = `${variation.name} | Luxury`

  const purchasable = useMemo(() => isTourPurchasable(offer), [offer])

  return <HeadData
    title={title}
    noIndex={!purchasable}
    description={description}
    imageId={image}
    imageAlt={imageAlt}
  />
}

export default TourV2HeadData
